export const getTrimId = (id: string) => id.split('_').reverse()[0];
